import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-375d5f4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { ref, Ref, watch, inject, onMounted } from "vue";
import { AppConfigServiceCtx } from "@/api";
import AppConfigService from "@/services/AppConfigService";
import { TermsAndConditions } from "@/interfaces/TermsAndConditions";


export default /*#__PURE__*/_defineComponent({
  __name: 'TermsAndConditionsView',
  setup(__props) {

const termsContent = ref();

const appConfigService: AppConfigService | undefined =
  inject(AppConfigServiceCtx);

onMounted(async () => {
  const tc: TermsAndConditions | undefined =
    await appConfigService?.fetchTermsAndConditions();
  if (tc != null && tc.content) {
    termsContent.value = tc.content;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", null, [
    _createElementVNode("span", { innerHTML: termsContent.value }, null, 8, _hoisted_1)
  ]))
}
}

})